import { Td } from 'components/Td/Td'
import { CircleButton } from 'pages/Shifts/Shifts.styled'
import { darkTheme, Flex, lightTheme, ProfilePicture, Table, TableBody, TableWrapper, Th, Tr } from 'styling/GlobalStyles'
import { AttendanceMonthlyCard, AttendanceOption, AttendanceOptionsWrapper } from './Attendance.styled'
import { v4 } from 'uuid'
import { addZero, areDatesSameDay, dateToMinutesUTC } from 'utils/helpers'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Avatar from '../../assets/images/profileAvatar.png'
import { BodyText, OtherText } from 'styling/Typography'
import { IAttendanceWorkScheduleInfo, IGetAllAttendanceSingleResponse } from 'types/api/attendanceApi.interface'
import { attendanceTypesOptions, attendanceTypesOptionsWithTime } from './data'
import { AppDispatch, RootState } from 'store'
import { clearAttendances, createAttendance, createMultipleAttendance, deleteAttendance, getAttendances } from 'features/attendance/attendanceSlice'
import useQueryPagination from 'hooks/useQueryPagination'

export const MonthlyDisplay = ({ params, attendance, setModal }: { params: any, attendance: IGetAllAttendanceSingleResponse[], setModal: any }) => {
    const [checked, setChecked] = useState([])
    const { darkMode } = useSelector((store: RootState) => store.globals)
    const [openDropdown, setOpenDropdown] = useState<{ userId: number, day: number } | null>(null)
    const dispatch = useDispatch<AppDispatch>()
    useQueryPagination({ fetchFunctions: [getAttendances], cleanUpFunctions: [clearAttendances], params, otherFunctions: [() => setChecked([])] })

    const getMonthlyHeaderDays = () => {
        const arr = []
        const date = new Date(params.dateFrom)
        const year = date.getFullYear()
        const month = date.getMonth()

        // Start of the month
        const day = new Date(year, month, 1)

        // Get total number of days in the month
        const daysInMonth = new Date(year, month + 1, 0).getDate()

        for (let i = 1; i <= daysInMonth; i++) {
            const dayOfWeek = day.getDay() // 0 = Sunday, 6 = Saturday
            const currentDay = `${addZero(day.getDate())}. ${addZero(
                day.getMonth() + 1,
            )}.`
            arr.push(<Td noTooltip w='29px' skew key={v4()} color={(dayOfWeek == 0 || dayOfWeek == 6) ? '#ff9900' : null} text={currentDay} />)
            day.setDate(day.getDate() + 1)
        }

        return arr
    }

    const renderAttendanceInputs = (dates: IAttendanceWorkScheduleInfo[], userId: number, userName: string, up: boolean) => {

        const arr = []
        const date = new Date(params.dateFrom)
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = new Date(year, month, 1)
        const daysInMonth = new Date(year, month + 1, 0).getDate()

        for (let i = 1; i <= daysInMonth; i++) {
            const attendanceForTheDay: IAttendanceWorkScheduleInfo = dates.find((dt) => {
                return areDatesSameDay(dt.date, day)
            })

            const { color, label } = attendanceTypesOptions.find(o => o.value == attendanceForTheDay?.workScheduleAttendanceInfo?.type) || { color: '#636363', label: 'Not Set' }
            const hasAttendance = !!attendanceForTheDay?.workScheduleAttendanceInfo?.type

            const handleDropdown = () => {
                if (openDropdown && openDropdown.userId === userId && openDropdown.day === i) {
                    setOpenDropdown(null)
                } else {
                    setOpenDropdown({ userId, day: i })
                }
            }

            const handleAttendance = async (a: { label: string, value: number, color: string }, id?: number) => {

                if (id) {
                    await dispatch(deleteAttendance({ id, userId }))
                    return
                }

                const currentDate = new Date(Date.UTC(year, month, i, 0, 0, 0, 0))
                const obj: any = {
                    id: attendanceForTheDay?.workScheduleAttendanceInfo?.id || null,
                    userId,
                    attendanceType: a,
                    checkIn: hasAttendance ? dateToMinutesUTC(attendanceForTheDay?.workScheduleAttendanceInfo.startDate) : (attendanceForTheDay?.workSchedule?.shift?.shiftStart || null),
                    checkOut: hasAttendance ? dateToMinutesUTC(attendanceForTheDay.workScheduleAttendanceInfo.endDate) : (attendanceForTheDay?.workSchedule?.shift?.minutes ? attendanceForTheDay?.workSchedule?.shift?.minutes + attendanceForTheDay?.workSchedule?.shift?.shiftStart : null),
                    offset: attendanceForTheDay?.workScheduleAttendanceInfo?.offset || null,
                    offsetType: attendanceForTheDay?.workScheduleAttendanceInfo?.offsetType || null,
                    shiftId: attendanceForTheDay?.workSchedule?.id || null,
                    date: currentDate,
                    userName: userName,
                    shiftName: attendanceForTheDay?.workSchedule?.shift?.name || null,
                }

                if (a.label.includes('(time input)') || (!attendanceForTheDay?.workSchedule?.id && [1, 4, 8, 11].includes(a.value))) {
                    if (a.value === 11) {
                        obj.attendanceType = attendanceTypesOptions.find(at => at.value == 11)
                    } else {
                        obj.attendanceType = attendanceTypesOptions.find(at => at.value == Number(a.value.toString().split('')[0]))
                    }
                    setModal({
                        open: true, value: { ...obj, userIds: checked }
                    })
                } else {
                    if (checked.length) {
                        delete obj.shiftName
                        delete obj.userName
                        if ([1, 4, 8, 111, 444, 888, 11].includes(a.value)) {
                            obj.checked = checked
                            if (a.value === 11) {
                                obj.attendanceType = attendanceTypesOptions.find(at => at.value == 11)
                            }
                            if (a.label.includes('(time input)')) {
                                obj.attendanceType = attendanceTypesOptions.find(at => at.value == Number(a.value.toString().split('')[0]))
                            }
                            obj.workScheduleIds = attendance.filter(at => checked.includes(at.id)).map(at => at.workScheduleInfos.find(i => areDatesSameDay(i.date, currentDate))?.workSchedule?.id).filter(s => s),
                                setModal({
                                    open: true, value: obj
                                })
                        } else {
                            await dispatch(createMultipleAttendance({
                                userIds: checked,
                                workScheduleIds: attendance.filter(at => checked.includes(at.id)).map(at => at.workScheduleInfos.find(i => areDatesSameDay(i.date, currentDate))?.workSchedule?.id).filter(s => s),
                                startDate: currentDate.toISOString(),
                                endDate: null,
                                type: a.value
                            }))
                        }
                    } else {
                        await dispatch(createAttendance(obj))
                    }
                }
                setOpenDropdown(null)
            }

            arr.push(
                <Td key={userId + '-' + i} noTooltip>
                    <AttendanceMonthlyCard color={((new Date(attendanceForTheDay?.date) < new Date()) && attendanceForTheDay?.workSchedule && !attendanceForTheDay.workScheduleAttendanceInfo && !attendanceForTheDay?.workSchedule?.shift.absence) ? (darkMode ? lightTheme['presentColor'] : darkTheme['presentColor']) : darkMode ? lightTheme[color] : darkTheme[color]} tabIndex={1} onBlur={() => setOpenDropdown(null)} onClick={handleDropdown} >
                        <OtherText color={hasAttendance ? 'black' : 'white'} weight='bold' >{hasAttendance ? label[0] : '/'}</OtherText>
                        {openDropdown && openDropdown.userId === userId && openDropdown.day === i && (
                            <AttendanceOptionsWrapper up={up} right={day.getDate() >= 25} >
                                {attendanceForTheDay?.workScheduleAttendanceInfo && <AttendanceOption onClick={() => handleAttendance(null, attendanceForTheDay?.workScheduleAttendanceInfo.id)} >
                                    <OtherText color='red' >Remove Attendance</OtherText>
                                </AttendanceOption>}
                                {attendanceTypesOptionsWithTime.filter(a => attendanceForTheDay?.workSchedule?.shift?.absence ? ![1, 4, 8, 11].includes(a.value) : true).map(a => <AttendanceOption onClick={() => handleAttendance(a)} key={a.value}><OtherText>{a.label}</OtherText></AttendanceOption>)}
                            </AttendanceOptionsWrapper>
                        )}
                    </AttendanceMonthlyCard>
                </Td>,
            )
            day.setDate(day.getDate() + 1)
        }

        return arr
    }
    const toggleAll = () => {
        if (checked.length < attendance.length) {
            for (const a of attendance) {
                const id = a.id

                if (!checked.includes(id)) {
                    setChecked((prev) => [...prev, id])
                }
            }
        } else {
            setChecked([])
        }
    }


    const toggle = (id: number) => {
        if (checked.includes(id)) {
            setChecked((prev) => {
                return prev.filter((item) => item !== id)
            })
        } else {
            setChecked((prev) => (!prev ? [id] : [...prev, id]))
        }
    }

    return <TableWrapper style={{ height: '100%' }} >
        <Table style={{ height: '100%' }} >
            <Th  >
                <Td w='3%' noTooltip>
                    <CircleButton
                        onClick={toggleAll}
                        checked={checked.length === attendance?.length}
                    />
                </Td>
                <Td w='27%' text='Employee' noTooltip />
                {getMonthlyHeaderDays()}
            </Th>
            <TableBody>
                {attendance &&
                    attendance.map((item, i) => {
                        const id = item.id
                        return (
                            <Tr borderHover key={id}>
                                <Td noTooltip w='30%'>
                                    <Flex center gap='1rem'>
                                        <CircleButton
                                            orange
                                            checked={checked.includes(id)}
                                            onClick={() => toggle(id)}
                                        />
                                        <ProfilePicture>
                                            <img
                                                src={item.profileImageUrl || Avatar}
                                                alt=''
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null
                                                    currentTarget.src = Avatar
                                                }}
                                            />
                                        </ProfilePicture>
                                        <BodyText>{item.firstName + ' ' + item.lastName}</BodyText>
                                    </Flex>
                                </Td>
                                {renderAttendanceInputs(item.workScheduleInfos, item.id, (item.firstName + ' ' + item.lastName), (attendance.length > 5) && (i >= attendance.length - 5))}
                            </Tr>
                        )
                    })}
            </TableBody>

        </Table>
    </TableWrapper>
}
